import { Type } from 'class-transformer'

import { CaseBase } from './CaseBase'
import { Product } from './Product'

export class Case extends CaseBase {
  @Type(() => Product)
  product?: Product
}
